import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from 'shared/actions/authentication';
import { setNewbuildingBrokerOfferBookingLoading } from 'shared/actions/newbuildingBrokerOfferBooking';
import { checkBookingExists } from 'shared/actions/newbuildingBrokerOfferBooking/checkBookingExists';
import { selectUser } from 'shared/selectors';
import { selectIsNewbuildingBookingAuthExperiment } from 'shared/selectors/abExperiments';
import { TSource } from 'shared/types/newbuildingBrokerOfferBooking';
import { trackBookingButtonClick } from 'shared/utils/newbuildingBroker/offerBooking';

import { useOfferBookingUrl } from './useOfferBookingUrl';

export function useBookingButtonClickHandler(
  source: TSource,
  gaLabel: string,
  onAuthenticaticationRequest?: () => void,
) {
  const offerBookingUrl = useOfferBookingUrl(source);
  const user = useSelector(selectUser);
  const isNewbuildingBookingAuthExperiment = useSelector(selectIsNewbuildingBookingAuthExperiment);

  const dispatch = useDispatch();

  const pageShowHandler = useCallback(
    (event: PageTransitionEvent) => {
      if (event.persisted) {
        dispatch(setNewbuildingBrokerOfferBookingLoading(false));
      }

      window.removeEventListener('pageshow', pageShowHandler);
    },
    [dispatch],
  );

  const navigationHandler = useCallback(() => {
    // Для скрытия индикатора загрузки при восстановлении страницы из back forward cache.
    window.addEventListener('pageshow', pageShowHandler);

    window.open(offerBookingUrl, '_self');
  }, [offerBookingUrl, pageShowHandler]);

  return useCallback(() => {
    trackBookingButtonClick(gaLabel, source);

    if (isNewbuildingBookingAuthExperiment && !user?.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => () => dispatch(checkBookingExists(navigationHandler)),
          viewData: {
            headingType: 'addFavorite',
          },
        }),
      );
      onAuthenticaticationRequest?.();
    } else {
      dispatch(checkBookingExists(navigationHandler));
    }
  }, [
    source,
    gaLabel,
    user,
    isNewbuildingBookingAuthExperiment,
    dispatch,
    navigationHandler,
    onAuthenticaticationRequest,
  ]);
}
